// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import DashedLabel from '../atoms/DashedLabel';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Cr... Remove this comment to see the full error message
import CrmTicketUpdatedMessage from './CrmTicketUpdatedMessage';
import CrmTicketAssociationUpdateMessage from './CrmTicketAssociationUpdateMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isTicketAssociationUpdateType } from 'conversations-message-history/crm-object-lifecycle-update/operators/isTicketAssociationUpdateType';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmTicketUpdateLabel = ({
  message,
  senders,
  userId,
  portalId,
  onTicketLinkClick = () => {}
}) => /*#__PURE__*/_jsx(DashedLabel, {
  transparent: true,
  children: isTicketAssociationUpdateType(message) ? /*#__PURE__*/_jsx(CrmTicketAssociationUpdateMessage, {
    message: message,
    senders: senders,
    userId: userId,
    portalId: portalId,
    onTicketLinkClick: onTicketLinkClick
  }) : /*#__PURE__*/_jsx(CrmTicketUpdatedMessage, {
    message: message,
    senders: senders,
    userId: userId
  })
});
CrmTicketUpdateLabel.displayName = 'CrmTicketUpdateLabel';
CrmTicketUpdateLabel.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  onTicketLinkClick: PropTypes.func,
  portalId: PropTypes.number,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmTicketUpdateLabel;